<script lang="ts">
  import ListAlert from '$shared/atoms/ListAlert/ListAlert.svelte';
  import FormItem from './FormItem.svelte';

  interface Props {
    data?: any;
    showBg?: boolean;
    isChild?: boolean;
  }

  let { data = {}, showBg = false, isChild = false }: Props = $props();

  const getValue = (value: DataListValue) => {
    if (value?.hasOwnProperty('actualValue')) {
      return value?.actualValue;
    }
    return value;
  };
</script>

<div class="complex-obj-form" class:showBg class:isChild>
  {#each Object.entries(data) as [key, value]}
    <div class="co-form-i">
      <FormItem
        {key}
        {isChild}
        value={getValue(value)}
        hide={value?.alert && !value?.alert.updated}
      />
    </div>
    {#if value?.alert}
      <div class="alert">
        <ListAlert alert={value.alert} />
      </div>
    {/if}
  {:else}
    <div class="invalid">No Data Found</div>
  {/each}
</div>

<style>
  .complex-obj-form {
    width: 100%;
    overflow: hidden;
  }
  .complex-obj-form .co-form-i:not(:last-child) {
    border-bottom: 1px solid var(--grey-xlight);
  }
  .showBg .co-form-i:nth-child(odd) {
    background-color: var(--grey-bg);
  }
</style>
